/* eslint-disable @typescript-eslint/no-explicit-any */
import Text from '@ingka/text';
import { Divider } from 'antd';
import React from 'react';
import { useTranslate } from '../../../../common/services/translationService.js';
import './CustomUnitDetailTab.css';

interface CustomUnitDetailTabProps {
  detailsTab: any;
  itemsTab: any;
  isPreview?: boolean;
}

const CustomUnitDetailTab = ({
  detailsTab, itemsTab, isPreview,
}: CustomUnitDetailTabProps) => {
  const cuoHfb = useTranslate('customUnit.overview.hfb');
  const cuoPra = useTranslate('customUnit.overview.pra');
  const cuoPa = useTranslate('tab.items.paNo');
  const cuoStatus = useTranslate('customUnit.overview.status');
  const cuoROC = useTranslate('tab.items.roc');
  const cuoPriceClass = useTranslate('tab.items.price_class');
  const cuoPrice = useTranslate('common.price');

  const totalPrice = () => {
    let total = 0;
    itemsTab?.importedItems?.forEach((item: any) => { total += item.totalPricePerQuantity; });
    return total?.toFixed(2);
  };

  const renderTabItems = (title: string, data: string) => (
    <>
      <div className="cuoSection">
        <Text className="cuoLabel">{title}</Text>
        <Text className="cuoValue">{data}</Text>
      </div>
      {title !== cuoPriceClass ? <Divider type="vertical" /> : null}
    </>
  );

  return (
    <>
      {renderTabItems(cuoPrice, `EUR ${totalPrice()}`)}
      {renderTabItems(cuoHfb, detailsTab?.Hfb)}
      {renderTabItems(cuoPra, detailsTab?.Pra)}
      {renderTabItems(cuoPa, detailsTab?.Pa)}
      {renderTabItems(
        cuoStatus,
        isPreview === true ? detailsTab?.unitState?.key : detailsTab?.unitState,
      )}
      {renderTabItems(cuoROC, detailsTab?.roc?.key)}
      {renderTabItems(cuoPriceClass, detailsTab?.priceClass?.key)}
    </>
  );
};

CustomUnitDetailTab.defaultProps = {
  isPreview: false,
};

export default CustomUnitDetailTab;
